import { useEffect, useState } from 'react';
import {
  listPersonalSecurityEvents,
  type PersonalSecurityEventResult,
} from './personal-security-events-api';
import '../styles/modules-my-account-security-journal.css';

const eventLabels: Readonly<Record<string, string>> = Object.freeze({
  ACCOUNT_ACTIVATED: 'Compte activé',
  ACCOUNT_SUSPENDED: 'Compte suspendu',
  ACCOUNT_REACTIVATED: 'Compte réactivé',
  ACCOUNT_ARCHIVED: 'Compte archivé',
  ADMINISTRATOR_DETACHED: 'Rôle Administrateur retiré',
  PASSWORD_RESET_COMPLETED: 'Mot de passe réinitialisé',
  PASSWORD_CHANGE_COMPLETED: 'Mot de passe modifié',
  EMAIL_CHANGE_COMPLETED: 'Adresse e-mail modifiée',
  SESSION_REVOKED: 'Session déconnectée',
  PASSKEY_REGISTERED: 'Passkey ajoutée',
  PASSKEY_REVOKED: 'Passkey supprimée',
  PASSKEY_LOGIN_SUCCEEDED: 'Connexion avec une passkey',
});

function formatDate(value: string): string {
  return new Intl.DateTimeFormat('fr-FR', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));
}

function eventLabel(eventType: string): string {
  return eventLabels[eventType] ?? 'Événement de sécurité';
}

export function PersonalSecurityJournal(): React.JSX.Element {
  const [events, setEvents] = useState<readonly PersonalSecurityEventResult[]>([]);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;

    void listPersonalSecurityEvents()
      .then((result) => {
        if (!active) return;
        setEvents(result);
      })
      .catch(() => {
        if (!active) return;
        setFailed(true);
      })
      .finally(() => {
        if (!active) return;
        setLoading(false);
      });

    return () => {
      active = false;
    };
  }, []);

  if (loading) {
    return <p className="my-account-journal-state">Chargement du journal de sécurité…</p>;
  }

  if (failed) {
    return (
      <p className="my-account-journal-state">Le journal de sécurité ne peut pas être affiché.</p>
    );
  }

  if (events.length === 0) {
    return <p className="my-account-journal-state">Aucun événement de sécurité enregistré.</p>;
  }

  return (
    <ol className="my-account-journal-list">
      {events.map((event, index) => (
        <li key={`${event.occurredAt}-${event.eventType}-${index}`}>
          <strong>{eventLabel(event.eventType)}</strong>
          <time dateTime={event.occurredAt}>{formatDate(event.occurredAt)}</time>
        </li>
      ))}
    </ol>
  );
}
